import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDouble = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1L6.55556 7L1 13M5.44444 1L11 7L5.44444 13",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowDouble;
